import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const CreateUser = lazy(() => import('@pages/users/CreateUser').then((m) => ({ default: m.CreateUser })));
const EditUser = lazy(() => import('@pages/users/EditUser').then((m) => ({ default: m.EditUser })));
const OnlineUsersList = lazy(() => import('@pages/users/OnlineUsersList'));
const UserAuditLogs = lazy(() => import('@pages/users/UserAuditLogs'));
const UserAuditTrail = lazy(() => import('@pages/users/UserAuditTrail'));
const UsersList = lazy(() => import('@pages/users/UsersList'));

// Route Components
const UsersTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('users-page-title-management')}>
        <UsersList />
      </PageWrapper>
    </Suspense>
  );
};
const UserCreatePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('users-page-title-create')}>
        <CreateUser />
      </PageWrapper>
    </Suspense>
  );
};
const UserEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('users-page-title-edit')}>
        <EditUser />
      </PageWrapper>
    </Suspense>
  );
};
const UserAuditLogsPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('users-page-title-audit-logs')}>
        <UserAuditLogs />
      </PageWrapper>
    </Suspense>
  );
};
const UserAuditTrailPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('users-page-title-audit-trail')}>
        <UserAuditTrail />
      </PageWrapper>
    </Suspense>
  );
};
const UsersOnlinePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('users-page-title-online')}>
        <OnlineUsersList />
      </PageWrapper>
    </Suspense>
  );
};
// Export Lazy-Loaded Route
export default {
  UsersTablePage,
  UserCreatePage,
  UserEditPage,
  UserAuditLogsPage,
  UserAuditTrailPage,
  UsersOnlinePage,
};
